import { ExpandTransition } from 'src/components/common/ExpandTransition';
import { ScrollToViewport } from 'src/components/common/ScrollToViewport';
import { EventAgendaScheduleDay } from 'src/modules/events/models';
import styled from 'styled-components';
import { Dispatch, SetStateAction } from 'react';
import { EventPageAgendaTimeslot } from 'src/modules/events/components/EventPage/EventPageAgendaSection/EventPageAgendaTimeslot';

const Section = styled.section`
  padding-top: 30px;
`;

const DatesRow = styled.div`
  display: flex;
  gap: 20px;
  align-items: baseline;

  h2 {
    margin: 0;
    padding: 0;
    font-size: 20px;
    line-height: 24px;
    font-weight: 600;
    text-transform: uppercase;
  }
  h3 {
    margin: 0;
    padding: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 16.8px;
  }
`;

export const EventPageAgendaScheduleDay = ({
  scheduleDay,
  expandedTimeslots,
  selectedTimeslots,
  setExpandedTimeslots,
  setSelectedTimeslots,
}: {
  scheduleDay: EventAgendaScheduleDay;
  day: number;
  expandedTimeslots: string[];
  selectedTimeslots: string[];
  setExpandedTimeslots: Dispatch<SetStateAction<string[]>>;
  setSelectedTimeslots: Dispatch<SetStateAction<string[]>>;
}) => {
  return (
    <Section id={scheduleDay.id}>
      <DatesRow>
        {/* TODO: Temporarily disabled due to problem after archiving timeslots. */}
        {/* <h2>{_('Day {number}', undefined, { number: day })}</h2> */}
        <h2>{scheduleDay.longLabel.toLocaleUpperCase()}</h2>
      </DatesRow>

      {scheduleDay.timeslots.map((timeslot) => {
        const isExpanded = expandedTimeslots.includes(timeslot.id);
        const isChecked = selectedTimeslots.includes(timeslot.id);
        return (
          <ScrollToViewport key={timeslot.id} active={isExpanded}>
            <ExpandTransition>
              <EventPageAgendaTimeslot
                timeslot={timeslot}
                isChecked={isChecked}
                toggleIsChecked={() => {
                  if (isChecked) {
                    setSelectedTimeslots((prev) =>
                      prev.filter((id) => id !== timeslot.id),
                    );
                  } else {
                    setSelectedTimeslots((prev) => prev.concat(timeslot.id));
                  }
                }}
                isExpanded={isExpanded}
                toggleIsExpanded={() =>
                  isExpanded
                    ? setExpandedTimeslots((prev) =>
                        prev.filter((id) => id !== timeslot.id),
                      )
                    : setExpandedTimeslots((prev) => prev.concat(timeslot.id))
                }
              />
            </ExpandTransition>
          </ScrollToViewport>
        );
      })}
    </Section>
  );
};
